import { INITIALIZE_USER, LANGUAGE_CHANGE, LOGOUT, SET_PHONE_LANGUAGE } from './types';
const initialState = {
  accountType: 'pat',
  communicationLanguage: '',
  country: '',
  created: 0,
  dateFormat: '1',
  dateOfBirth: 0,
  email: '',
  firstName: '',
  id: '',
  lastName: '',
  phoneLanguage: '',
  system: {},
  timeFormat: '1',
  uiLanguage: '',
  uom: '0'
};
export const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case INITIALIZE_USER:
      return {
        ...state,
        ...action.user
      };
    case LANGUAGE_CHANGE:
      if (action.language === state.uiLanguage) {
        return state;
      }
      return {
        ...state,
        uiLanguage: action.language
      };
    case SET_PHONE_LANGUAGE:
      return {
        ...state,
        phoneLanguage: action.language
      };
    case LOGOUT:
      return {
        ...initialState,
        country: state.country,
        uiLanguage: state.uiLanguage
      };
    default:
      return state;
  }
};